import React, { ReactNode } from 'react';

interface IGenericChartCardProps {
  children: ReactNode;
  title: string | JSX.Element;
  extraClasses?: string;
}

// Este arquivo é usado apenas para os cards do módulo Perfil socioeconômico e demográfico
export const GenericChartCard = ({
  children,
  title,
  extraClasses,
}: IGenericChartCardProps): JSX.Element => {
  return (
    <div className="chart-card--full-container">
      <div className="chart-card--full-container--header-container">
        {title}
      </div>
      <div
        className={`chart-card--full-container--component-container scroll ${
          extraClasses ? extraClasses : ''
        }`}
      >
        {children}
      </div>
    </div>
  );
};
